module.exports = __webpack_public_path__ + "static/media/icon-camera.8e3c6158.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-camera.svg
// module id = 262
// module chunks = 0